const STORAGE_KEY = 'dashboard_auth_token';
const ADMIN_KEY = 'dashboard_admin';

export function getDashboardToken() {
  if (typeof window === 'undefined') return '';
  return sessionStorage.getItem(STORAGE_KEY) || '';
}

export function setDashboardSession(token, admin) {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem(STORAGE_KEY, token);
  if (admin) {
    sessionStorage.setItem(ADMIN_KEY, JSON.stringify(admin));
  }
}

export function getDashboardAdmin() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(ADMIN_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearDashboardSession() {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(STORAGE_KEY);
  sessionStorage.removeItem(ADMIN_KEY);
}

export function getDashboardAuthHeaders() {
  const token = getDashboardToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}
